import { PanelLeftClose } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconPanelLeftClose(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <PanelLeftClose />
    </IconWrapper>
  );
}
